import styled from '@emotion/styled';

export const FormWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bgGrey};
  padding: 14px 20px;
  border-radius: 8px;
`;
